"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelAuraVfxStepArgs = void 0;
const uuid_1 = require("uuid");
class CancelAuraVfxStepArgs {
    constructor(cancelVfxArgsId) {
        this.cancelVfxArgsId = cancelVfxArgsId;
        this.__typeName = "CancelAura";
        this.id = (0, uuid_1.v4)();
    }
}
exports.CancelAuraVfxStepArgs = CancelAuraVfxStepArgs;
